$('body').on('click', '.rc_cancel-btn', function(e) {
    e.preventDefault();
    $('#subscriptionManagementOverlay').addClass('active');
})

$('#subscriptionManagementOverlay').on('click', '.exit-overlay-full', function(e) {
    console.log('exit no sidebar');

    let $modal = $('body').find('#te-modal')
    $modal.find('.close-sidebar').click();
    setTimeout(() => {
        $('#subscriptionManagementOverlay').removeClass('active');
      }, 300);
})

$('#subscriptionManagementOverlay').on('click', '.exit-overlay-sidebar', function(e) {
    console.log('exit with sidebar');
    $('#subscriptionManagementOverlay').removeClass('active');
})